// extracted by mini-css-extract-plugin
module.exports = {"round":"roundCheckbox_round__3ojpb"};